import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RefreshTokenInterceptor } from './refresh-token.interceptor';
import { DataResponseInterceptor } from './data-response.interceptor';
import { ErrorResponseInterceptor } from './error-response.interceptor';
import { NoCacheInterceptor } from './no-cache.interceptor';

export const HTTPInterceptorsProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DataResponseInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorResponseInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: NoCacheInterceptor, multi: true },
];
